module.exports = __webpack_public_path__ + "fonts/typicons.a509074c.eot";